const animalIcons = ['seal', 'goose', 'walrus', 'caribou', 'fish', 'whale', 'bear', 'wolf', 'fox']
export const isIceAge = feature => feature.properties['Natural Feature'] === 'Ice Edge'
export const isAnimal = feature => animalIcons.includes(feature.properties['icon'] ? feature.properties['icon'].toLowerCase() : '')
